import { render, staticRenderFns } from "./collapsable-list-item.vue?vue&type=template&id=f9393a26"
import script from "./collapsable-list-item.vue?vue&type=script&lang=js"
export * from "./collapsable-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9393a26')) {
      api.createRecord('f9393a26', component.options)
    } else {
      api.reload('f9393a26', component.options)
    }
    module.hot.accept("./collapsable-list-item.vue?vue&type=template&id=f9393a26", function () {
      api.rerender('f9393a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/collapsable-list-item.vue"
export default component.exports